import produce from "immer";
import { createAction } from "redux-smart-actions";
import { createSelector } from "reselect";
import { KomutRedux } from "../base/types/KomutRedux";
import { RootState } from "../base/types/RootState";
import { LoginInputParams, LoginResponseModel } from "./type";

const LOGOUT_ACTION = "LOGOUT_ACTION";

const LOGIN_ACTION = "LOGIN_ACTION";
const SET_USER = "SET_USER";

export interface AuthReducer {
  user?: LoginResponseModel;
}

export interface AuthActions {
  loginAction: any;
  logoutAction: any;
  setUser: any;
}

const auth = new KomutRedux<AuthReducer, AuthActions>();

auth.setInitialState({
  user: undefined,
});

auth.setActions({
  loginAction: createAction(LOGIN_ACTION, (payload: LoginInputParams) => ({
    payload,
  })),
  logoutAction: createAction(LOGOUT_ACTION),
  setUser: createAction(SET_USER, (payload: LoginResponseModel) => ({
    payload,
  })),
});

auth.setRedusers(
  produce((draft: AuthReducer, action: any) => {
    switch (action.type) {
      case SET_USER:
        draft.user = action.payload;
        break;
      case LOGOUT_ACTION:
        draft.user = auth.initialState.user;
        break;
    }
  }, auth.initialState)
);

// ** SELECTORS *** \\
const userState = (state: RootState) => state.auth.user;
export const userSelector = createSelector([userState], (user) => user);

const userTokenState = (state: RootState) => state.auth.user?.AccessToken.Token;
export const getUserToken = createSelector([userTokenState], (token) => token);

const localeState = (state: RootState) => state.language.language?.Code;
export const localeSelector = createSelector([localeState], (lang) => lang);
const loggedState = (state: RootState) => state.auth.user?.Email;
export const loggedSelector = createSelector([loggedState], (email) =>
  email !== undefined ? true : false
);

export const getApiParams = createSelector(
  [localeState, userTokenState],
  (lang, token) => {
    return {
      lang,
      token: token || "",
    };
  }
);

export default auth;
